// source: live_mode_entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.jp.singcolor.LiveMode', null, global);
/**
 * @enum {number}
 */
proto.jp.singcolor.LiveMode = {
  LIVE_MODE_TYPE_NONE: 0,
  LIVE_MODE_TYPE_DEFAULT_VIDEO: 1,
  LIVE_MODE_TYPE_RADIO: 2,
  LIVE_MODE_TYPE_VTUBER: 3
};

goog.object.extend(exports, proto.jp.singcolor);
